<template>
    <div class="animated fadeIn">
  
      
      <b-card class="card-accent-info" header="Jumper AK2 por Lote">

        <b-card-body>
  
          <b-row>
            <!--
            <b-col cols="auto" class="mr-auto">
                <b-form-group>
                    <b-button variant="outline-primary" :pressed.sync="tableSelectable">{{tableSelectable ? 'Desabilitar Seleção ' : 'Habilitar Seleção'}}</b-button>
                    &nbsp;
                    <b-button variant="outline-primary" v-show="tableSelectable" @click="selectAllRows">Selecionar todos</b-button>
                    &nbsp;
                    <b-button variant="outline-primary" v-show="tableSelectable" @click="clearSelectedRows">Limpar seleção</b-button>                  
              </b-form-group>
            </b-col>
            <b-col cols="auto" class="">
              <b-form-group>
                <b-button variant="vine" class="mr-1 btn-brand" @click="enableDisable()"  v-show="tableSelectable"><i class="fa fa-toggle-on"></i><span>Alterar Status</span></b-button>
                &nbsp;
                <b-button variant="github" class="mr-1 btn-brand" @click="openEditModal(null)"><i class="fa fa-plus"></i><span>Novo País</span></b-button>
              </b-form-group>
            </b-col>
            -->
          </b-row>
              
  
          <b-row>
           <!--
            <b-col cols="auto">
              <b-form-group>
                  <label for="code">Código</label>
                  <b-form-input v-model="filters.code" type="text" id="code" placeholder="Código"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="auto">
              <b-form-group>
                  <label>Período</label>
                  <date-picker v-model="filters.startDate" :config="options"></date-picker>
              </b-form-group>
            </b-col>
            <b-col cols="auto">
              <b-form-group>
                  <label>&nbsp;</label>
                  <date-picker v-model="filters.endDate" :config="options"></date-picker>
              </b-form-group>
            </b-col>
            -->
            <b-col cols="auto">
              <b-form-group>
                  <label for="name">Filtro</label>
                  <b-form-input v-model="filters.code" type="text" id="filter" placeholder="Filtro"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="auto" class="mr-auto" style="padding-top: 12px;">
                <b-form-group>
                  <p></p>
                  <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="refreshData()"><i class="fa fa-search"></i><span>Localizar</span></b-button>
                </b-form-group>
              </b-col>
            <!--
            <b-col cols="auto" class="mr-auto">
              <b-form-group>
                  <label for="name">Filtro</label>
                  <b-form-input type="text" id="filter" placeholder="Filtro"></b-form-input>
              </b-form-group>
            </b-col>
          -->
            <b-col cols="auto" class="">
              <b-form-group >
                  <label for="perPage">Linhas</label>
                  <b-form-select v-model="perPage" id="perPage"
                    :plain="true"
                    :options="[100,300,600]">
                  </b-form-select>
                </b-form-group>
            </b-col>
            
          </b-row>
        
          <div v-for="item in this.items" :key="item.id">
          <b-card class="card-accent-info" :header="item.labels[0] != undefined ? item.labels[0].partNumber + ( item.labels[0].partName ? ' - ' + item.labels[0].partName: '' ) : filters.code">

            <!--<div v-show="item.labels[0] !== undefined">-->
            <div v-for="label in item.labels" :key="label.id" >
              <b-row>
                <b-col class="text-primary text-right">Part Number: </b-col>
                <b-col>{{ label.partNumber }}</b-col>
                <b-col class="text-primary text-right">Item: </b-col>
                <b-col>{{ label.partName }}</b-col>
              </b-row>
              <b-row>
                <b-col class="text-primary text-right">Ordem: </b-col>
                <b-col>{{ label.orderCode }}</b-col>
                <b-col class="text-primary text-right">Quantidade: </b-col>
                <b-col>{{ label.quantity }}</b-col>
              </b-row>
              <b-row>
                <b-col class="text-primary text-right">Data: </b-col>
                <b-col>{{ $utils.rastreaDateString(label.labelDate) }}</b-col>
                <b-col class="text-primary text-right">Unidade: </b-col>
                <b-col>{{ label.unit }}</b-col>
              </b-row>
              <b-row>
                <b-col class="text-primary text-right">Linha: </b-col>
                <b-col>{{ $utils.rastreaDateString(label.labelDate) }}</b-col>
                <b-col class="text-primary text-right"></b-col>
                <b-col></b-col>
              </b-row>
              
            </div>
            
            <p style="height: 15px"></p>

            <b-card class="card-accent-danger" header="Lotes">
              <b-table
                  :items="item.items"
                  :fields="fields"
                  :select-mode="selectMode"
                  responsive="sm"
                  ref="selectableTable"
                  :primary-key="primaryKey"
                  :tbody-transition-props="transProps"
                  sort-icon-left
                  hover
                  striped
                  >
    
                  <template v-slot:cell(labelDate)="data">
                      {{ $utils.rastreaDateString(data.item.labelDate) }}
                  </template>
                  
                  <template v-slot:cell(createdIn)="data">
                      {{ $utils.rastreaDateString(data.item.createdIn)  }}
                  </template>
    
                  <!--
                  
                  <template #cell(show_details)="row">
                      <b-row>
                          <b-col cols="auto" class="mr-auto">
                              <b-form-group>
                              <b-button size="sm" variant="dark"  @click="buttonState()" class="mr-1 btn-brand"><i class="fa fa-flag-checkered"></i></b-button>
                              <b-button size="sm" variant="dark"  @click="buttonCity()" class="mr-1 btn-brand"><i class="fa fa-building-o"></i></b-button>
                              </b-form-group>
                          </b-col>
                      </b-row>
                  </template>
                  
                
                  
                  <template v-slot:cell(ispublic)="data">
                      <c-switch class="" color="primary" :checked="data.item.ispublic==1" label variant="pill" v-bind="switchLabelIcon" /> 
                  </template>
                  -->
              </b-table>
            </b-card>

            <b-card class="card-accent-success" header="Peças Fabricadas">
              <b-table
                  :items="item.parents"
                  :fields="parentsFields"
                  :select-mode="selectMode"
                  responsive="sm"
                  ref="parentsTable"
                  :primary-key="primaryKey"
                  :tbody-transition-props="transProps"
                  sort-icon-left
                  hover
                  striped
                  >
    
                  <template v-slot:cell(labelDate)="data">
                      {{ $utils.rastreaDateString(data.item.labelDate) }}
                  </template>
                  
    
                  <!--
                  
                  <template #cell(show_details)="row">
                      <b-row>
                          <b-col cols="auto" class="mr-auto">
                              <b-form-group>
                              <b-button size="sm" variant="dark"  @click="buttonState()" class="mr-1 btn-brand"><i class="fa fa-flag-checkered"></i></b-button>
                              <b-button size="sm" variant="dark"  @click="buttonCity()" class="mr-1 btn-brand"><i class="fa fa-building-o"></i></b-button>
                              </b-form-group>
                          </b-col>
                      </b-row>
                  </template>
                  
                
                  
                  <template v-slot:cell(ispublic)="data">
                      <c-switch class="" color="primary" :checked="data.item.ispublic==1" label variant="pill" v-bind="switchLabelIcon" /> 
                  </template>
                  -->
              </b-table>
            </b-card>
          
          </b-card>
        </div>
          
  
        </b-card-body>
     </b-card>
  
  
     <b-modal
              v-model="editModal"
              id="edit-modal"
              centered
              hide-footer
              title="País"
              size="lg">
  
        <b-form @submit.stop.prevent="onSubmit">
  
        <div class="animated fadeIn">
      
          <b-row>
            <b-col md="12">
              
              <b-form>
                <b-form-group
                description=""
                label="Id"
                label-for="id"
                :label-cols="3"
                :horizontal="true">
                <b-form-input v-model="selectedItem.id" id="id" type="text" readonly></b-form-input>
              </b-form-group>          
              </b-form>
              </b-col>
          </b-row>
  
          <b-row>
            <b-col md="12">
              
              <b-form>
                <b-form-group
                description=""
                label="País"
                label-for="name"
                :label-cols="3"
                :horizontal="true">
                <b-form-input v-model="selectedItem.name" id="name" type="text"></b-form-input>
              </b-form-group>          
              </b-form>
            </b-col>
          </b-row>
  
          <b-row>
            <b-col md="12">
              <b-form>
                <b-form-group
                description=""
                label="Código"
                label-for="code"
                :label-cols="3"
                :horizontal="true">
                <b-form-input v-model="selectedItem.code" id="code" type="text"></b-form-input>
              </b-form-group>          
              </b-form>
            </b-col>
          </b-row>
  
          <b-row>
            <b-col md="12">
              <b-form>
                <b-form-group
                description=""
                label="DDD"
                label-for="phonecode"
                :label-cols="3"
                :horizontal="true">
                <b-form-input v-model="selectedItem.code" id="phonecode" type="text"></b-form-input>
              </b-form-group>          
              </b-form>
            </b-col>
          </b-row>
  
  
          <b-input-group class="mb-4">
              <div class="text-danger" v-if="this.errorMessage && this.errorMessage != ''"><i class="fa fa-exclamation-triangle fa-lg mt-4"></i> {{ this.errorMessage }}</div>
          </b-input-group>
        
          <div slot="footer" class="text-right">
            <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="enableDisable()" v-show="this.selectedItem.id && this.selectedItem.st=='I'"><i class="fa fa-times"></i><span>Habilitar</span></b-button>
            <b-button variant="html5" class="mr-1 btn-brand" @click="enableDisable()" v-show="this.selectedItem.id && this.selectedItem.st=='A'"><i class="fa fa-times"></i><span>Desabilitar</span></b-button>
            <b-button variant="github" class="mr-1 btn-brand" @click="save()"><i class="fa fa-check"></i><span>Salvar Documento</span></b-button>
           
          </div>
                
        </div>
        </b-form>
  
      </b-modal>
  
    </div>
  
  </template>
  
  <script>
  import Vue from 'vue'
  import axios from "axios";
  import { Switch as cSwitch } from '@coreui/vue'
  
  /* data */
  import datePicker from 'vue-bootstrap-datetimepicker';
  import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';


  /* Toast */
  import VueNotifications from 'vue-notifications'
  import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
  //import { table } from 'console'
  
  const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
  }
  
  miniToastr.init({types: toastTypes})
  
  function toast ({title, message, type, timeout, cb}) {
    return miniToastr[type](message, title, timeout, cb)
  }
  
  const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
  }
  VueNotifications.setPluginOptions(options)
  
  Vue.use(VueNotifications, options)
  /* Toast - End */
  
  const newItem = {id: null, name: '', description: '', st: 'A', _rowVariant: ''}
  
  export default {
    name: 'tables',
    components: {
      Event,
      cSwitch,
      datePicker
    },
    data: () => {
      return {
  
       
        options: {
            format: 'DD/MM/YYYY HH:mm:ss',
            useCurrent: false,
        },

        isBusy: false,
        currentPage: 1,
        switchLabelIcon: {
            dataOn: '\u2713',
            dataOff: '\u2715'
        },
        switchLabelTxt: {
            dataOn: 'yes',
            dataOff: 'no'
        },
  
        tableRef: "table",
        tableSelectable: false,
        errorMessage: '',
        editModal: false,
        filters: {
          code: '',
          key: '',
          //startDate: new Date().setUTCHours(0,0,0,0),
          // endDate: new Date().setUTCHours(23,59,59,999)
        },
  
        modes: ['multi', 'single', 'range'],
        selectMode: 'multi',
        selected: [],
        transProps: {
          // Transition name
          name: 'flip-list'
        },
        primaryKey: "id",
  
        selectedItem: newItem,
        items: [
          //{id: 1, st: 'A', name: 'Brasil', code: 'br', phonecode: "55", _rowVariant: 'none'},
        ],
        fields: [
          //{key: 'id' },
          {key: 'partId', label: 'Part Number', sortable: true, thStyle: { width: "100px" }, tdClass: 'align-middle' },
          {key: 'partName', label: 'Item', sortable: true },
          {key: 'batchId', label: 'Lote', sortable: true, thStyle: { width: "100px" }, tdClass: 'align-middle' },
          {key: 'quantityUsed', label: 'Quantidade', sortable: true, thStyle: { width: "100px" }, tdClass: 'align-middle' },
          {key: 'createdIn', label: 'Utilização', sortable: true, thStyle: { width: "100px" }, tdClass: 'align-middle' },
          {key: 'labelDate', label: 'Entrada/Fabricação', sortable: true, thStyle: { width: "100px" }, tdClass: 'align-middle' },
          //{key: 'status', label: 'Status', sortable: true, thStyle: { width: "40px" } },
          //{key: 'show_details', label: "", thStyle: { width: "100px" } },
          
        ],
        parentsFields: [
          //{key: 'id' },
          {key: 'barCode', label: 'Código', sortable: true, thStyle: { width: "100px" }, tdClass: 'align-middle' },
          {key: 'partNumber', label: 'Part Number', sortable: true },
          {key: 'lineCode', label: 'Linha', sortable: true, thStyle: { width: "100px" }, tdClass: 'align-middle' },
          {key: 'labelDate', label: 'Entrada/Fabricação', sortable: true, thStyle: { width: "100px" }, tdClass: 'align-middle' },
          //{key: 'status', label: 'Status', sortable: true, thStyle: { width: "40px" } },
          //{key: 'show_details', label: "", thStyle: { width: "100px" } },
          
        ],
        /*
        fields: [
            'show_details',
            { key: 'first_name', sortable: true }, 
            { key: 'last_name', sortable: true }
        ],
        items: [
          { isActive: true, age: 40, first_name: 'Dickerson', last_name: 'Macdonald' },
          { isActive: false, age: 21, first_name: 'Larsen', last_name: 'Shaw' },
          { isActive: false, age: 89, first_name: 'Geneva', last_name: 'Wilson', _showDetails: false },
          { isActive: true, age: 38, first_name: 'Jami', last_name: 'Carney' }
        ],
        */
        filterable: ['username'],
        sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
        perPage: 300
      }
    },
    computed: {
      totalRows: function () { return this.getRowCount() },
      filteredItems() {
        try {
            return this.items.filter(item => {
              return this.filters.key == '' 
                  || (item.boxCode.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1)
                  || (item.bagCode.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1) 
                  || (item.code.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1)
            })
        }
        catch(e) {
            return this.items;
        }
      }
    },
    methods: {
      getRowCount: function () {
        if(this.items)
            return this.items.length
        else
            return 0;
      },
     
      save() {
        console.log('Salvando país')
        console.log(this.selectedItem);
  
        toast ({
            type: VueNotifications.types.warn,
            title: 'País',
            message: 'Salvando',
            timeout: 3000
          })
      },
      enableDisable() {
        console.log('Habilitando/desabilitando país')
        console.log(this.selectedItem);
      },
      closeEditModal() {
        this.editModal = false;
      },
      openEditModal(item) {
        if(item == null) {
            this.selectedItem = newItem;      
        }
        else {
            this.selectedItem = JSON.parse(JSON.stringify(item));
        }
        this.editModal = true;
      },
      onRowSelected(items) {
        this.selected = items
        //console.log(items);
        //this.openEditModal(items[0])
      },
      selectAllRows() {
        this.$refs.selectableTable.selectAllRows();
      },
      clearSelectedRows() {
        this.$refs.selectableTable.clearSelected();
      },
      rowClicked(item) {
          if(!this.tableSelectable) {
            console.log(item);
            this.clearSelectedRows();
          
            this.openEditModal(item);
        }
      },
      getBadge (status) {
        return status === 'A' ? 'primary'
            : status === 'I' ? 'danger'
            : status === 'Pending' ? 'warning'
                : status === 'Banned' ? 'danger' : 'primary'
      },
      toggleBusy() {
        this.isBusy = !this.isBusy
      },
      buttonState() {
  
      },
      buttonCity() {
        
      },
      async refreshData() {
        try {
          this.isBusy = true;
          var s = this;
          var currentUser = this.$store.state.currentUser;

          if(s.filters && s.filters.code.length > 3) {
            await axios.get(
                this.$store.state.ws_url + "/rastrea/aptiv/tracebatch?key=" + s.filters.code + "&sid=&uid=100"
            ).then(function(resp) {
              if(resp.data.obj.items) {
                s.items = resp.data.obj.items;
              }
            })
          
            this.isBusy = false; 
          }
          else {
            this.isBusy = false;
            toast ({
              type: VueNotifications.types.warn,
              title: 'Filtro',
              message: 'Entre com o código da peça ou etiqueta.',
              timeout: 5000
            })
          }
          
        } catch (e) {
            console.log(e)
  
            toast ({
              type: VueNotifications.types.error,
              title: 'Permissão',
              message: 'Sem permissão de acesso. Verifique o acesso Dados de Referência.',
              timeout: 5000
            })
        }
      }
    },
    mounted: function() {
      //this.refreshData();
    }
  }
  </script>
  
  <style scoped>
  table#table-transition-example .flip-list-move {
  transition: transform 1s;
  }
  </style>